<template>
  <div>
    <form-field-input
      v-autofocus
      label="Task"
      ref="label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
      autofocus
    ></form-field-input>

    <form-field-select
      v-model="taskDue"
      label="Task Due"
      @change="changedTaskDue"
    >
      <option :value="1">Immediately when lead put in this status</option>
      <option :value="3">Days after lead put in this status</option>
<!--      <option :value="2">At the status change by date, at time of creation</option>-->
<!--      <option :value="4">Days before the status change by date</option>-->
    </form-field-select>

    <form-field-input
      label="Day Offset"
      v-show="taskDue === 3 || taskDue === 4"
      v-model.number="form.day_offset"
      v-format.number
    ></form-field-input>

    <form-field-select
      label="User Role"
      v-model="form.user_role"
      :validation-errors="validationErrors.user_role"
    >
      <option :value="null">Not Set</option>
      <option v-for="role in userRoles" :value="role.value">{{role.label}}</option>
    </form-field-select>

    <form-field-select-users
      label="Assigned User"
      v-model="form.assign_to_id"
      :validation-errors="validationErrors.assign_to_id"
      help-text="If the selected role is not set on the lead, then this fallback user will be set instead"
    ></form-field-select-users>

    <form-field-select
      label="Required"
      v-model="form.is_required_to_change_status"
      :validation-errors="validationErrors.is_required_to_change_status"
      help-text="A required task must be completed before the lead can move into another status"
    >
      <option :value="true">Yes</option>
      <option :value="false">No</option>
    </form-field-select>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>

    <form-field-input
      label="Task Link"
      v-model="form.link"
      :validation-errors="validationErrors.link"
      help-text="Link to video or docs on how to do the task"
    ></form-field-input>

    <div class="template-footer" v-if="showButtons">
      <div class="mr-auto">
        <button-link
          color="is-danger"
          v-if="form.id"
          :disabled="isDeleting"
          :loading="isDeleting"
          @click="detachFromAutomation"
        >Delete</button-link>
      </div>

      <b-button
        outlined
        :disabled="isSaving"
        :loading="isSaving"
        type="is-primary"
        size="is-small"
        @click="save"
      >{{ (form.id) ? 'Update' : 'Create'}}</b-button>
    </div>

    <modal-container>
      <modal-default
        title="Can't Delete Task Template"
        ref="detachAutomationsModal"
      >
        <div class="detach-modal">
          <p class="detach-modal--message">This is a list of all the places this task is being currently being used.</p>

          <div class="detach-modal--box" v-if="statusesInContactNotMadeState.length">
            <h2 class="detach-modal--box--heading">Contact Not Made State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInContactNotMadeState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>

          <div class="detach-modal--box" v-if="statusesInActiveState.length">
            <h2 class="detach-modal--box--heading">Active State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInActiveState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>

          <div class="detach-modal--box" v-if="statusesInFollowUpState.length">
            <h2 class="detach-modal--box--heading">Follow Up State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInFollowUpState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>

          <div class="detach-modal--box" v-if="statusesInCompletedState.length">
            <h2 class="detach-modal--box--heading">Follow Up State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInCompletedState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>

          <div class="detach-modal--box" v-if="statusesInDeadState.length">
            <h2 class="detach-modal--box--heading">Follow Up State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInDeadState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>

          <div class="detach-modal--box" v-if="statusesInNotALeadState.length">
            <h2 class="detach-modal--box--heading">Follow Up State And Automation</h2>
            <ul class="detach-modal--box--list">
              <li v-for="status in statusesInNotALeadState" :key="status.id">
                {{ status.label }}
              </li>
            </ul>
          </div>
        </div>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import {FormMixin} from "../../../../forms/forms.mixin";
import {ENUMS} from "../../../../services/enums";

export default {
  name: "TaskTemplateForm",
  data() {
    return {
      userRoles: ENUMS.UserRoleEnum,
      taskDue: 1,
      form: {
        user_role: null,
      },
      validationErrors: {},
      isSaving: false,
      isDeleting: false,
      statuses: {}
    }
  },
  mixins: [FormMixin],
  props: {
    formData: Object,
    addTaskAutomationId: {
      type: Number,
      default: null
    },
    taskListId: {
      type: Number,
      default: null
    },
    showButtons: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    this.setInitialState();
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        this.setInitialState()
      }
    }
  },
  computed: {
    statusesInContactNotMadeState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.Contacting.value) {
          statues.push(status);
        }
      }
      return statues;
    },
    statusesInActiveState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.Active.value) {
          statues.push(status);
        }
      }
      return statues;
    },
    statusesInFollowUpState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.FollowUp.value) {
          statues.push(status);
        }
      }
      return statues;
    },
    statusesInCompletedState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.Completed.value) {
          statues.push(status);
        }
      }
      return statues;
    },
    statusesInDeadState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.Dead.value) {
          statues.push(status);
        }
      }
      return statues;
    },
    statusesInNotALeadState() {
      let statues = [];

      for (const [key, status] of Object.entries(this.statuses)) {
        if (status.state === ENUMS.StatusStateEnum.NonLead.value) {
          statues.push(status);
        }
      }
      return statues;
    },
  },
  methods: {
    setInitialState() {
      this.isSaving = false;
      this.isDeleting = false;
      this.form = (this.formData) ? this.$utils.clone(this.formData) : this.buildDefaultTaskTemplate();

      // If day offset is zero then its a preset option
      if (this.form.day_offset === 0) {
        if (this.form.offset_direction === 1) {
          this.taskDue = 1;
        }
        // if (this.form.offset_direction === 2) {
        //   this.taskDue = 2;
        // }
      } else {
        if (this.form.offset_direction === 1) {
          this.taskDue = 3;
        }
        // if (this.form.offset_direction === 2) {
        //   this.taskDue = 4;
        // }
      }
    },
    changedTaskDue(taskDue) {
      if (taskDue === 1) {
        this.form.day_offset = 0;
        this.form.offset_direction = 1;
      }
      // if (taskDue === 2) {
      //   this.form.day_offset = 0;
      //   this.form.offset_direction = 2;
      // }
      if (taskDue === 3) {
        this.form.offset_direction = 1;
      }
      // if (taskDue === 4) {
      //   this.form.offset_direction = 2;
      // }
    },
    buildDefaultTaskTemplate() {
      return {
        add_task_automation_id: this.addTaskAutomationId,
        task_list_id: this.taskListId,
        label: '',
        description: '',
        assign_to_id: null,
        is_required_to_change_status: false,
        link: null,
        day_offset: 0,
        offset_direction: 1,
        user_role: null,
      }
    },
    save() {
      this.isSaving = true;

      if (this.form.id) {
        return this.$api.taskTemplates.update(this.form)
          .then((response) => {
            this.$emit('updated', response.data);
            this.setInitialState();

            this.$buefy.toast.open({
              message: "Task template was updated",
              type: 'is-success'
            })

            return response;
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationErrors = error.response.data.errors;
            }

            throw error;
          })
          .finally(() => {
            this.isSaving = false;
          });
      } else {
        return this.$api.taskTemplates.create(this.form)
          .then((response) => {
            this.$emit('created', response.data);
            this.setInitialState();
            this.isSaving = false;

            this.$buefy.toast.open({
              message: "Task template was created",
              type: 'is-success'
            })


            return response;
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationErrors = error.response.data.errors;
            }
            this.isSaving = false;
            throw error;
          });
      }
    },
    detachFromAutomation() {
      this.isDeleting = true;

      return this.$api.taskTemplates.detachFromAutomation(this.form.id, this.addTaskAutomationId).then((response) => {
        this.$emit('deleted', this.form);
        this.setInitialState();
        this.isDeleting = false;
        return response;
      }).catch((error)=>{
        this.isDeleting = false;
        throw error;
      });
    },
    delete() {
      return this.$api.taskTemplates.delete(this.form.id).then((response) => {
        this.$emit('deleted', this.form);
        this.setInitialState();
        return response;
      }).catch((error)=>{
        if (error.response.status === 422 && error.response.data.errors.task_automations) {
          let taskAutomations = error.response.data.errors.task_automations;
          this.statuses = {};
          taskAutomations.forEach(taskAutomation => {
            let statusId = taskAutomation.status.id;

            if (!this.statuses[statusId]) {
              this.statuses[statusId] = taskAutomation.status;
              this.statuses[statusId].taskTemplates = []
            }

            this.statuses[statusId].taskTemplates.push(taskAutomation.status.id);

            this.$refs.detachAutomationsModal.open();
          });
        }

        throw error;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.template-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.status-add-checklist-item {
  padding: 15px 0 0;
}
.detach-modal {
  &--message {
    margin-bottom: 1.25rem;
    font-size: 0.875rem;
    color: $dark;
    line-height: 1.3;
  }

  &--box {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }

    &--heading {
      margin-bottom: 0.5rem;
    }

    &--list {
      padding-left: 0.75rem;
      font-size: 0.875rem;
      color: $dark;
      line-height: 1.5;
    }
  }
}
</style>
